var map = {
	"./1.jpg": 250,
	"./2.jpg": 251,
	"./3.jpg": 252,
	"./4.jpg": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Hero ^\.\/.*\.jpg$
// module id = 112
// module chunks = 0